import { addDays, startOfDay } from 'date-fns';
/**
 * Horizon de recherche maximal : on ne propose pas de vol au-delà de J+358.
 * Ex. le 27/07/2026 -> dernier jour sélectionnable le 20/07/2027.
 */
export const MAX_SEARCH_DAYS_AHEAD = 358;
/** Dernier jour sélectionnable dans la barre de recherche (aujourd'hui + 358 j, inclus). */
export const getMaxSearchDate = () => addDays(startOfDay(new Date()), MAX_SEARCH_DAYS_AHEAD);
/** Hors fenêtre de recherche : jour passé ou au-delà de J+358. */
export const isOutsideSearchWindow = (date) => date < startOfDay(new Date()) || date > getMaxSearchDate();
